import React from "react";
import {
  Users,
  CheckCircle,
  Clock,
  IndianRupee,
} from "lucide-react";

export default function PayrollProcessingSummaryCards({ payrolls }) {
  const totalEmployees = payrolls.length;

  const processed = payrolls.filter(
    (item) => item.status === "Processed"
  ).length;

  const pending = payrolls.filter(
    (item) => item.status === "Pending"
  ).length;

  const totalPayroll = payrolls.reduce(
    (sum, item) => sum + Number(item.netSalary || 0),
    0
  );

  const cards = [
    {
      title: "Total Employees",
      value: totalEmployees,
      icon: <Users size={28} />,
    },
    {
      title: "Processed",
      value: processed,
      icon: <CheckCircle size={28} />,
    },
    {
      title: "Pending",
      value: pending,
      icon: <Clock size={28} />,
    },
    {
      title: "Total Payroll",
      value: `₹ ${totalPayroll.toLocaleString("en-IN")}`,
      icon: <IndianRupee size={28} />,
    },
  ];

  return (
    <div className="finance-summary-grid">
      {cards.map((card) => (
        <div className="finance-summary-card" key={card.title}>
          <div className="finance-summary-icon">
            {card.icon}
          </div>

          <div className="finance-summary-content">
            <h4>{card.title}</h4>
            <h2>{card.value}</h2>
          </div>
        </div>
      ))}
    </div>
  );
}